var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": ['new-modal-main-views-wrapper', 'modals-share-your-design', 'gutters'],
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "modals-share-your-design-title no-gutters",
      "elementType": "h2",
      "text": _vm.translations.shareYourDesignTitle
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "modals-share-your-design-text",
      "elementType": "div"
    }
  }, [_c('CustomText', {
    attrs: {
      "elementType": "span",
      "text": _vm.translations.shareYourDesignText1
    }
  }), _c('br'), _c('CustomText', {
    attrs: {
      "elementType": "span",
      "text": _vm.translations.shareYourDesignText2
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "modals-share-your-design-share-area",
      "elementType": "div"
    }
  }, [_c('button', {
    staticClass: "modals-share-your-design-share-area-copy-link",
    attrs: {
      "disabled": _vm.recipeIsLoading
    },
    on: {
      "click": _vm.copyLink,
      "mouseout": _vm.onMouseOut
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "icon-share modals-share-your-design-share-area-copy-link-icon",
      "elementType": "span"
    }
  }), _c('CustomText', {
    attrs: {
      "customClass": "modals-share-your-design-share-area-copy-link-text",
      "elementType": "span",
      "text": _vm.translations.shareYourDesignCopyLink
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "id": "copyMessage",
      "customClass": "modals-share-your-design-share-area-copy-message custom-position",
      "elementType": "div"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.translations.shareYourDesignCopyLinkM) + "\n      ")])], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "large-12 columns",
      "elementType": "div"
    }
  }, [_c('form', {
    ref: "form",
    staticClass: "modals-share-your-design-form",
    attrs: {
      "id": "share-form",
      "method": "post"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.sendMessage.apply(null, arguments);
      }
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "modals-share-your-design-form-modal-scroll-area",
      "elementType": "div"
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "required-input",
      "elementType": "div"
    }
  }, [_c('CustomInput', {
    attrs: {
      "customClass": "custom-input",
      "id": "input_name",
      "type": "text",
      "maxlength": "64",
      "placeholder": _vm.translations.shareYourDesignName,
      "required": "true"
    },
    on: {
      "change": _vm.disableSendButton
    },
    model: {
      value: _vm.shareDesignFormData.from_name,
      callback: function callback($$v) {
        _vm.$set(_vm.shareDesignFormData, "from_name", $$v);
      },
      expression: "shareDesignFormData.from_name"
    }
  }), _c('CustomText', {
    attrs: {
      "customClass": "req",
      "elementType": "span",
      "text": "*"
    }
  })], 1), _c('CustomContainer', {
    attrs: {
      "customClass": "required-input",
      "elementType": "div"
    }
  }, [_c('CustomInput', {
    attrs: {
      "customClass": "custom-input",
      "id": "input_email",
      "type": "email",
      "maxlength": "250",
      "placeholder": _vm.translations.shareYourDesignEmail,
      "required": "true"
    },
    on: {
      "change": _vm.disableSendButton
    },
    model: {
      value: _vm.shareDesignFormData.from_email,
      callback: function callback($$v) {
        _vm.$set(_vm.shareDesignFormData, "from_email", $$v);
      },
      expression: "shareDesignFormData.from_email"
    }
  }), _c('CustomText', {
    attrs: {
      "customClass": "req",
      "elementType": "span",
      "text": "*"
    }
  })], 1), _vm._l(_vm.addAnotherRecipients, function (recipient, index) {
    return _c('CustomContainer', {
      key: index,
      attrs: {
        "customClass": "modals-share-your-design-form-add-recipient-container",
        "elementType": "div"
      }
    }, [_c('CustomContainer', {
      attrs: {
        "data-id": index,
        "customClass": "required-input",
        "elementType": "div"
      }
    }, [_c('CustomInput', {
      attrs: {
        "customClass": "custom-input",
        "id": "input_recipients_".concat(index),
        "placeholder": _vm.translations.shareYourDesignEmail,
        "maxlength": "250",
        "required": "true",
        "type": "email"
      },
      on: {
        "change": _vm.disableSendButton
      },
      model: {
        value: recipient.emailAddress,
        callback: function callback($$v) {
          _vm.$set(recipient, "emailAddress", $$v);
        },
        expression: "recipient.emailAddress"
      }
    }), _c('CustomText', {
      attrs: {
        "customClass": "req",
        "elementType": "span",
        "text": "*"
      }
    }), index != 0 ? _c('CustomContainer', {
      attrs: {
        "customClass": "modals-share-your-design-form-add-recipient-container-close",
        "elementType": "div"
      },
      on: {
        "click": function click($event) {
          return _vm.removeRecipient(index);
        }
      }
    }, [_c('CustomText', {
      attrs: {
        "customClass": "icon-close",
        "elementType": "span"
      }
    })], 1) : _vm._e()], 1)], 1);
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "modals-share-your-design-form-add-another-area",
      "elementType": "div"
    }
  }, [_c('button', {
    staticClass: "add-another",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.addRecipient.apply(null, arguments);
      }
    }
  }, [_c('CustomText', {
    attrs: {
      "customClass": "icon-plus",
      "elementType": "span"
    }
  }), _c('CustomText', {
    attrs: {
      "customClass": "add-another-text",
      "elementType": "span",
      "text": _vm.translations.shareYourDesignAddAnother
    }
  }), _vm._v("\n               \n              "), _c('CustomText', {
    attrs: {
      "customClass": "max-add-another-text",
      "elementType": "span",
      "text": _vm.translations.shareYourDesignMaxSize
    }
  })], 1)]), _c('CustomTextArea', {
    attrs: {
      "customClass": "modals-share-your-design-form-textarea-message",
      "maxlength": "2000",
      "id": "textarea_message",
      "placeholder": _vm.translations.shareYourDesignMessage
    },
    model: {
      value: _vm.shareDesignFormData.message,
      callback: function callback($$v) {
        _vm.$set(_vm.shareDesignFormData, "message", $$v);
      },
      expression: "shareDesignFormData.message"
    }
  })], 2), _c('CustomContainer', {
    attrs: {
      "customClass": "modals-share-your-design-form-check gutters"
    }
  }, [_c('label', {
    staticClass: "modals-share-your-design-form-check-label",
    attrs: {
      "for": "checkbox1"
    }
  }, [_c('CustomCheckbox', {
    attrs: {
      "id": "checkbox1",
      "name": "newsletter",
      "checked": _vm.enableCheck
    }
  }), _c('CustomText', {
    attrs: {
      "elementType": "span",
      "text": _vm.translations.shareYourDesignCheckBoxM
    }
  })], 1)]), _c('CustomContainer', {
    attrs: {
      "customClass": "bottom-gutter",
      "elementType": "div"
    }
  }, [!_vm.recaptchaVerified && !!_vm.configuration.enableRecaptcha ? _c('vue-recaptcha', {
    ref: "recaptchaShareCustomizer",
    attrs: {
      "id": "recaptcha",
      "loadRecaptchaScript": true,
      "sitekey": _vm.recaptchaKey
    },
    on: {
      "verify": _vm.onVerifyRecaptcha,
      "error": _vm.errorRecaptcha
    }
  }) : _vm._e()], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }